import { http } from '../../../../api/http';
import type { VentaListResult, FiltroVenta } from '../types/explorador.types';

export class ExploradorVentaService {
  private static readonly ENDPOINTS = {
    LIST: '/ventas',
  };

  public static async getVentas(filtro: FiltroVenta): Promise<VentaListResult> {
    try {
      const params = new URLSearchParams();
      if (filtro.fechaDesde) params.append('fechaDesde', filtro.fechaDesde);
      if (filtro.fechaHasta) params.append('fechaHasta', filtro.fechaHasta);
      if (filtro.idCliente) params.append('idCliente', filtro.idCliente.toString());
      if (filtro.idVendedor) params.append('idVendedor', filtro.idVendedor.toString());
      if (filtro.idComprobante) params.append('idComprobante', filtro.idComprobante.toString());
      if (filtro.estado) params.append('estado', filtro.estado);
      if (filtro.serie) params.append('serie', filtro.serie);
      if (filtro.busqueda) params.append('busqueda', filtro.busqueda);
      params.append('pagina', filtro.pagina.toString());
      params.append('tamanioPagina', filtro.tamanioPagina.toString());

      const response = await http.get(`${this.ENDPOINTS.LIST}?${params.toString()}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching ventas:', error);
      throw error;
    }
  }
}
